const normalizeText = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

const normalizeLegacyExposureIntervention = (paper) => {
  const current = normalizeText(paper?.exposure_intervention);
  if (current) return current;

  const intervention = normalizeText(paper?.intervention);
  const comparator = normalizeText(paper?.comparator);

  if (intervention && comparator) {
    return `${intervention} / ${comparator}`;
  }
  return intervention || comparator || "";
};

export const normalizeHistoryPaper = (paper) => {
  if (!paper || typeof paper !== "object") {
    return {};
  }

  return {
    ...paper,
    research_question:
      normalizeText(paper.research_question) || "",
    design:
      normalizeText(paper.design) ||
      normalizeText(paper.study_design) ||
      "",
    population:
      normalizeText(paper.population) || "",
    exposure_intervention: normalizeLegacyExposureIntervention(paper),
    endpoint:
      normalizeText(paper.endpoint) ||
      normalizeText(paper.outcome) ||
      "",
    statistics:
      normalizeText(paper.statistics) || "",
    key_results:
      normalizeText(paper.key_results) ||
      normalizeText(paper.summary) ||
      "",
  };
};

export const normalizeHistoryDetails = (searchDetails) => {
  if (!searchDetails || typeof searchDetails !== "object") {
    return searchDetails;
  }

  const papers = Array.isArray(searchDetails.papers)
    ? searchDetails.papers.map(normalizeHistoryPaper)
    : [];

  return {
    ...searchDetails,
    papers,
    paper_results: papers,
  };
};
